import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

// 引入公共CSS文件
import './assets/public.css'

import { createI18n } from 'vue-i18n';
import { pl, zhHans } from 'vuetify/locale'
import { vClickOutside } from './directives/click-outside'

const i18n = createI18n({
  locale: 'zh-Hans', // 设置默认语言为中文
  messages: { 'zh-Hans': zhHans } // 添加中文语言包
});
 
const vuetify = createVuetify({
  locale: {
    locale: 'zhHans',
    fallback: 'sv',
    messages: { zhHans, pl },
  },
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      // 确保PDF图标别名正确
      'file-pdf': 'mdi-file-pdf-box',
      'file-pdf-box': 'mdi-file-pdf-box',
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          background: '#F5F5F5'
        },
      },
    },
  },
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.directive('click-outside', vClickOutside)

app.mount('#app')
